module.exports = __webpack_public_path__ + "img/fmk-no-strap.053b13a2.png";